
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

interface Driver {
  id: string;
  supplier_id: string;
  supervisor_id: string;
  name_ar: string;
  name_en: string;
  mobile: string;
  email: string;
  has_access_permission: boolean;
  suppliers: { name_ar: string };
  employees: { name:string };
  created_at: string;
}

interface DriversTableProps {
  drivers: Driver[];
  onEdit: (driver: Driver) => void;
  onDelete: (id: string) => void;
}

export function DriversTable({ drivers, onEdit, onDelete }: DriversTableProps) {
  return (
    <Card>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>الاسم</TableHead>
            <TableHead>المورد</TableHead>
            <TableHead>المشرف</TableHead>
            <TableHead>الموبايل</TableHead>
            <TableHead>صلاحية الدخول</TableHead>
            <TableHead>الإجراءات</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {drivers.map((driver) => (
            <TableRow key={driver.id}>
              <TableCell className="font-medium">{driver.name_ar}</TableCell>
              <TableCell>{driver.suppliers?.name_ar || "غير محدد"}</TableCell>
              <TableCell>{driver.employees?.name || "غير محدد"}</TableCell>
              <TableCell>{driver.mobile || "غير محدد"}</TableCell>
              <TableCell>
                  <Badge variant={driver.has_access_permission ? "default" : "secondary"}>
                    {driver.has_access_permission ? "نعم" : "لا"}
                  </Badge>
              </TableCell>
              <TableCell>
                <div className="flex gap-2">
                    <Button variant="outline" size="sm" onClick={() => onEdit(driver)}>
                        تعديل
                    </Button>
                    <Button variant="destructive" size="sm" onClick={() => onDelete(driver.id)}>
                        حذف
                    </Button>
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Card>
  );
}
